module.exports = __webpack_public_path__ + "static/media/m8.36efa20c.jpg";